import React from 'react';
import { Divider, Switch, Tag, Typography } from '@duxton-web/ui';
import styled from 'styled-components';

import TimesliceValues from './timeslice-values';
import {
  ExperimentAssignmentStrategy,
  getAssignmentStrategy,
  isTimeSliceShuffleStrategy,
} from '@/features/experiment/constants';
import {
  useExperimentContext,
  useExperimentDispatchContext,
} from '@/features/experiment/contexts/experiment-context';
import { updateAssignmentStrategy } from '@/features/experiment/store/actions/experiment/action-creators';

const TimeSlice = () => {
  const experimentContext = useExperimentContext();
  const experimentDispatch = useExperimentDispatchContext();
  const { configurations } = experimentContext;
  const experimentStrategy = getAssignmentStrategy(configurations);

  if (!isTimeSliceShuffleStrategy(experimentStrategy)) return null;

  return (
    <Wrapper>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Header>
          <Switch
            size="small"
            style={{ width: 28 }}
            onChange={(v: boolean) => {
              if (v) {
                experimentDispatch(
                  updateAssignmentStrategy(
                    ExperimentAssignmentStrategy.TIME_SLICE_SHUFFLE,
                  ),
                );
              } else {
                experimentDispatch(
                  updateAssignmentStrategy(
                    ExperimentAssignmentStrategy.TIME_SLICE_V2,
                  ),
                );
              }
            }}
            checked={
              experimentStrategy ===
              ExperimentAssignmentStrategy.TIME_SLICE_SHUFFLE
            }
          />
          <div>Time shuffle</div>
          <Tag bordered={false} color="success">
            Recommended
          </Tag>
        </Header>
        <Typography.Metadata type="secondary">
          Randomly shuffle the order of treatments upon experiment creation.
        </Typography.Metadata>
      </div>

      <Divider style={{ marginInline: 0, margin: '8px 0' }} />

      <TimesliceValues />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  font-size: 14px;
  gap: 8px;
`;

export default TimeSlice;
